import React from "react";
import { Button } from "../ui/button";
import { RefreshCw, Loader2 } from "lucide-react";

function RegenerateSection({ onRegenerate, isRegenerating, contentType }) {
  return (
    <div className="mt-8 pt-6 border-t border-white/10">
      <div className="flex items-center justify-between">
        <div>
          <h4 className="text-white font-medium">Not happy with the results?</h4>
          <p className="text-white/50 text-sm">
            Click regenerate to create new {contentType} content with AI
          </p>
        </div>
        <Button
          onClick={onRegenerate}
          disabled={isRegenerating}
          className="bg-purple-500 hover:bg-purple-600 text-white font-semibold px-6"
        >
          {isRegenerating ? (
            <>
              <Loader2 className="w-4 h-4 mr-2 animate-spin" />
              Regenerating...
            </>
          ) : (
            <>
              <RefreshCw className="w-4 h-4 mr-2" />
              Regenerate {contentType}
            </>
          )}
        </Button>
      </div>
    </div>
  );
}

export default RegenerateSection;
